import { useContext } from "react";
import {
  VerificationContext,
  VerificationContextValue,
} from "./VerificationProvider";

export const useVerificationContext = (): VerificationContextValue => {
  return useContext<VerificationContextValue>(VerificationContext);
};
